<app-responsive-topbar></app-responsive-topbar>
<div class="bg-container centered" style="display: flex;">
    <router-outlet></router-outlet>
</div>